module.exports = __webpack_public_path__ + "img/final-fi.82d785a7.svg";